import React from 'react';
import { connect } from 'react-redux';

import { getListingsById } from '../../ducks/marketplaceData.duck';
import { isScrollingDisabled } from '../../ducks/ui.duck';

import PageBuilder from '../PageBuilder/PageBuilder';

import SectionFeaturedProducts from './SectionFeaturedProducts';
import SectionFeaturedService from './SectionFeaturedService';
import SectionHero from './SectionHero';
import SectionInfo from './SectionInfo';
import SectionReview from './SectionReview';
import SectionPromotedListings from './SectionPromotedListings';

const landingPageData = {
  sections: [
    { sectionType: 'customHero', sectionId: 'landing-hero' },
    { sectionType: 'customInfo', sectionId: 'landing-info' },
    { sectionType: 'customPromotedListings', sectionId: 'landing-promoted-listings' },
    { sectionType: 'customFeaturedProducts', sectionId: 'landing-featured-products' },
    { sectionType: 'customFeaturedService', sectionId: 'landing-featured-service' },
    { sectionType: 'customReview', sectionId: 'landing-review' },
  ],
};

/**
 * Landing page with locally controlled content and dynamic featured listings.
 */
export const LandingPageComponent = props => {
  const {
    productListings,
    productInProgress,
    serviceListings,
    serviceInProgress,
    promotedListings,
    promotedInProgress,
  } = props;

  const sectionComponents = {
    customHero: { component: SectionHero },
    customInfo: { component: SectionInfo },
    customPromotedListings: {
      component: sectionProps => (
        <SectionPromotedListings
          {...sectionProps}
          listings={promotedListings}
          inProgress={promotedInProgress}
        />
      ),
    },
    customFeaturedProducts: {
      component: sectionProps => (
        <SectionFeaturedProducts
          {...sectionProps}
          listings={productListings}
          inProgress={productInProgress}
        />
      ),
    },
    customFeaturedService: {
      component: sectionProps => (
        <SectionFeaturedService
          {...sectionProps}
          listings={serviceListings}
          inProgress={serviceInProgress}
        />
      ),
    },
    customReview: { component: SectionReview },
  };

  return (
    <PageBuilder
      pageAssetsData={landingPageData}
      inProgress={false}
      currentPage="LandingPage"
      options={{ sectionComponents }}
    />
  );
};

const mapStateToProps = state => {
  const { products, services, promoted } = state.LandingPage;
  const promotedIds = (promoted.listingIds || []).map(id => id.uuid);

  const productListings = getListingsById(state, products.listingIds).filter(
    l => l && l.id && !promotedIds.includes(l.id.uuid)
  );

  const serviceListings = getListingsById(state, services.listingIds).filter(
    l => l && l.id && !promotedIds.includes(l.id.uuid)
  );

  return {
    productListings,
    productInProgress: products.inProgress,
    serviceListings,
    serviceInProgress: services.inProgress,
    promotedListings: getListingsById(state, promoted.listingIds),
    promotedInProgress: promoted.inProgress,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

export default connect(mapStateToProps)(LandingPageComponent);
